import React, { useState } from "react";
import Container from "../components/Container";
import { useTheme } from "../context/ThemeContext";
import usePortfolioStore from "../store/store";
import showToast from "../utils/toast";
import { useTranslation } from "react-i18next";

const Contact = () => {
  const { colors } = useTheme();
  const { t } = useTranslation("common");
  const createContactRemote = usePortfolioStore((s) => s.createContactRemote);
  const [form, setForm] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (submitting) return;

    const payload = {
      ...form,
      createdAt: new Date().toISOString(),
    };

    setSubmitting(true);
    try {
      const result = await createContactRemote(payload);
      if (result?.success) {
        showToast.success("Message sent successfully.");
        setForm({ name: "", email: "", subject: "", message: "" });
      } else {
        showToast.error(result?.error?.message || "Failed to send message.");
      }
    } catch (err) {
      showToast.error(err?.message || "Failed to send message.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Container>
      <div className="max-w-3xl mx-auto py-8 md:py-12 px-4 sm:px-6">
        <h1 className={`text-lg md:text-2xl lg:text-4xl font-bold ${colors.text.primary} mb-3 md:mb-4`}>
          {t("contact.title", "Contact")}
        </h1>
        <p className={`text-sm sm:text-base ${colors.text.secondary} mb-6`}>
          {t("contact.description", "Feel free to reach out — email me or use the form below.")}
        </p>

        <div
          className={`bg-white dark:bg-gray-800 rounded-lg p-3 sm:p-4 md:p-6 border ${colors.border}`}
        >
          <a
            href="mailto:you@example.com"
            className={`inline-block mb-3 md:mb-4 text-[11px] sm:text-xs md:text-sm ${colors.button.primary} px-3 md:px-4 py-2 rounded-lg`}
          >
            {t("contact.email", "Email: you@example.com")}
          </a>

          <form onSubmit={handleSubmit} className="space-y-2 md:space-y-3">
            <input
              name="name"
              placeholder={t("contact.namePlaceholder", "Your name")}
              value={form.name}
              onChange={(e) => setForm((p) => ({ ...p, name: e.target.value }))}
              className="w-full px-3 py-2 border rounded-md bg-transparent text-[11px] sm:text-xs md:text-sm"
              required
            />
            <input
              name="email"
              type="email"
              placeholder={t("contact.emailPlaceholder", "Your email")}
              value={form.email}
              onChange={(e) =>
                setForm((p) => ({ ...p, email: e.target.value }))
              }
              className="w-full px-3 py-2 border rounded-md bg-transparent text-[11px] sm:text-xs md:text-sm"
              required
            />
            <input
              name="subject"
              type="text"
              placeholder={t("contact.subjectPlaceholder", "Subject")}
              value={form.subject}
              onChange={(e) =>
                setForm((p) => ({ ...p, subject: e.target.value }))
              }
              className="w-full px-3 py-2 border rounded-md bg-transparent text-[11px] sm:text-xs md:text-sm"
            />
            <textarea
              name="message"
              placeholder={t("contact.messagePlaceholder", "Message")}
              rows={5}
              value={form.message}
              onChange={(e) =>
                setForm((p) => ({ ...p, message: e.target.value }))
              }
              className="w-full px-3 py-2 border rounded-md bg-transparent text-[11px] sm:text-xs md:text-sm"
              required
            />
            <button
              type="submit"
              disabled={submitting}
              className={`inline-block ${colors.button.primary} px-3 md:px-4 py-2 rounded-lg text-[11px] sm:text-xs md:text-sm`}
            >
              {submitting ? t("contact.sending", "Sending...") : t("contact.send", "Send")}
            </button>
          </form>
        </div>
      </div>
    </Container>
  );
};

export default Contact;
